{
  "button_add_more_images": [
    {
      "type": 0,
      "value": "Aggiungi altre immagini"
    }
  ],
  "button_approve": [
    {
      "type": 0,
      "value": "Approva"
    }
  ],
  "button_back": [
    {
      "type": 0,
      "value": "Indietro"
    }
  ],
  "button_back_to_cart": [
    {
      "type": 0,
      "value": "Gallery"
    }
  ],
  "button_back_to_login": [
    {
      "type": 0,
      "value": "Torna al login"
    }
  ],
  "button_bill_to_room": [
    {
      "type": 0,
      "value": "Conto della camera"
    }
  ],
  "button_buy_more": [
    {
      "type": 0,
      "value": "Acquista altro"
    }
  ],
  "button_cancel": [
    {
      "type": 0,
      "value": "Annulla"
    }
  ],
  "button_close": [
    {
      "type": 0,
      "value": "Chiudi"
    }
  ],
  "button_complete_purchase": [
    {
      "type": 0,
      "value": "Completa l'acquisto"
    }
  ],
  "button_continue": [
    {
      "type": 0,
      "value": "Continua"
    }
  ],
  "button_credit_or_debit_card": [
    {
      "type": 0,
      "value": "Carta di credito o di debito"
    }
  ],
  "button_customer_login": [
    {
      "type": 0,
      "value": "Back to Customer Login"
    }
  ],
  "button_done": [
    {
      "type": 0,
      "value": "FATTO"
    }
  ],
  "button_download": [
    {
      "type": 0,
      "value": "Scarica"
    }
  ],
  "button_edit_order": [
    {
      "type": 0,
      "value": "Modifica ordine"
    }
  ],
  "button_enter": [
    {
      "type": 0,
      "value": "Invio"
    }
  ],
  "button_forgot": [
    {
      "type": 0,
      "value": "Dimenticata"
    }
  ],
  "button_got_it": [
    {
      "type": 0,
      "value": "Capito"
    }
  ],
  "button_image_view_next": [
    {
      "type": 0,
      "value": "Avanti (freccia a destra)"
    }
  ],
  "button_image_view_previous": [
    {
      "type": 0,
      "value": "Indietro (freccia a sinistra)"
    }
  ],
  "button_image_view_zoom": [
    {
      "type": 0,
      "value": "Zoom avanti/indietro"
    }
  ],
  "button_log_out": [
    {
      "type": 0,
      "value": "Esci"
    }
  ],
  "button_login": [
    {
      "type": 0,
      "value": "Accedi"
    }
  ],
  "button_lookup_gallery": [
    {
      "type": 0,
      "value": "Galleria di ricerca"
    }
  ],
  "button_more_images": [
    {
      "type": 0,
      "value": "Altre immagini"
    }
  ],
  "button_new_order": [
    {
      "type": 0,
      "value": "Nuovo ordine"
    }
  ],
  "button_ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "button_price_guide": [
    {
      "type": 0,
      "value": "Guida ai prezzi"
    }
  ],
  "button_print": [
    {
      "type": 0,
      "value": "Stampa"
    }
  ],
  "button_process": [
    {
      "type": 0,
      "value": "Processo"
    }
  ],
  "button_purchase": [
    {
      "type": 0,
      "value": "Compra"
    }
  ],
  "button_refresh": [
    {
      "type": 0,
      "value": "Aggiorna"
    }
  ],
  "button_remove": [
    {
      "type": 0,
      "value": "Rimuovi"
    }
  ],
  "button_remove_prints": [
    {
      "type": 0,
      "value": "Rimuovi stampe"
    }
  ],
  "button_review_and_purchase": [
    {
      "type": 0,
      "value": "Rivedi e acquista"
    }
  ],
  "button_review_cart": [
    {
      "type": 0,
      "value": "Cart"
    }
  ],
  "button_select": [
    {
      "type": 0,
      "value": "Seleziona"
    }
  ],
  "button_selected_print_sizes": [
    {
      "type": 0,
      "value": "Formati di stampa selezionati ("
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "button_send_link": [
    {
      "type": 0,
      "value": "Invia link"
    }
  ],
  "button_send_links": [
    {
      "type": 0,
      "value": "Invia link"
    }
  ],
  "button_share": [
    {
      "type": 0,
      "value": "Condividi"
    }
  ],
  "button_stay": [
    {
      "type": 0,
      "value": "Rimani"
    }
  ],
  "button_stripe_reader": [
    {
      "type": 0,
      "value": "Stripe Reader"
    }
  ],
  "button_tilby": [
    {
      "type": 0,
      "value": "Tilby"
    }
  ],
  "button_toggle_access_codes": [
    {
      "type": 0,
      "value": "Toggle Access Codes"
    }
  ],
  "button_view_gallery": [
    {
      "type": 0,
      "value": "Visualizza galleria"
    }
  ],
  "button_view_my_gallery": [
    {
      "type": 0,
      "value": "Visualizza la mia galleria"
    }
  ],
  "button_view_receipt": [
    {
      "type": 0,
      "value": "Visualizza ricevuta"
    }
  ],
  "cart_add_image_no_cost": [
    {
      "type": 0,
      "value": "Puoi aggiungere altre immagini senza alcun costo"
    }
  ],
  "cart_apply_coupon": [
    {
      "type": 0,
      "value": "Applica"
    }
  ],
  "cart_buy_all_at_price": [
    {
      "type": 0,
      "value": "Acquista Tutto Il prezzo è "
    },
    {
      "type": 1,
      "value": "amount"
    }
  ],
  "cart_buy_all_discount_description": [
    {
      "type": 0,
      "value": "Ottieni tutte le immagini per "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " "
    }
  ],
  "cart_buy_all_discount_label": [
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " per tutti"
    }
  ],
  "cart_cart_details": [
    {
      "type": 0,
      "value": "Dettagli del carrello"
    }
  ],
  "cart_cart_total": [
    {
      "type": 0,
      "value": "Totale carrello"
    }
  ],
  "cart_checkout": [
    {
      "type": 0,
      "value": "Pagamento"
    }
  ],
  "cart_coupon_code": [
    {
      "type": 0,
      "value": "Codice coupon"
    }
  ],
  "cart_coupon_code_instructions": [
    {
      "type": 0,
      "value": "Please enter your coupon code to apply it to your order."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Click continue to proceed to checkout"
    }
  ],
  "cart_credit_debit_card": [
    {
      "type": 0,
      "value": "Carta di credito o di debito"
    }
  ],
  "cart_digital_image": [
    {
      "type": 0,
      "value": "Immagine/i digitale/i"
    }
  ],
  "cart_digitals": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Immagine digitale"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Immagini digitali"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_digitals_and_prints": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Immagine digitale"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Immagini digitali"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "digitals"
    },
    {
      "type": 0,
      "value": " & "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Stampa"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Stampe"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_discount_label": [
    {
      "type": 0,
      "value": "Acquista altre immagini per ottenere uno sconto"
    }
  ],
  "cart_image_free_of_charge": [
    {
      "type": 0,
      "value": "Questa "
    },
    {
      "type": 1,
      "value": "imageDesc"
    },
    {
      "type": 0,
      "value": " sarà gratuita."
    }
  ],
  "cart_link_to_gallery": [
    {
      "type": 0,
      "value": "Un link alla tua galleria è stato inviato a "
    },
    {
      "type": 1,
      "value": "email"
    }
  ],
  "cart_no_photos_available": [
    {
      "type": 0,
      "value": "No images are currently available. If you just had photos taken, they will be available here soon so check back.  If you have not yet had photos taken, please see a photographer to get started"
    }
  ],
  "cart_no_selected_image": [
    {
      "type": 0,
      "value": "Seleziona le immagini da acquistare prima del pagamento"
    }
  ],
  "cart_on_date": [
    {
      "type": 0,
      "value": "su "
    },
    {
      "type": 1,
      "value": "date"
    }
  ],
  "cart_packages_discount_description": [
    {
      "type": 0,
      "value": "Ottieni "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " immagine"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " immagini"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " per "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_description_all": [
    {
      "type": 0,
      "value": "Ottieni tutte le immagini per "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_description_range": [
    {
      "type": 0,
      "value": "Ottieni "
    },
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " le immagini per "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_label": [
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " per "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_label_range": [
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " per "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_price_guide": [
    {
      "type": 0,
      "value": "Guida ai prezzi"
    }
  ],
  "cart_price_guide_notes": [
    {
      "type": 0,
      "value": "Consulta la Guida ai prezzi"
    }
  ],
  "cart_prints": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Stampa"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Stampe"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_purchase": [
    {
      "type": 0,
      "value": "Compra"
    }
  ],
  "cart_purchase_unavailable": [
    {
      "type": 0,
      "value": "Mobile purchasing is unavailable.  Please visit the on-site kiosk to view"
    }
  ],
  "cart_purchased": [
    {
      "type": 0,
      "value": "Acquistato"
    }
  ],
  "cart_purchasing": [
    {
      "type": 0,
      "value": "Acquisti"
    }
  ],
  "cart_sorry_charge_problem": [
    {
      "type": 0,
      "value": "Scusa, si è verificato un problema che non ha consentito l'esecuzione del pagamento. Riprova e contattaci se il problema persiste."
    }
  ],
  "cart_standard_price": [
    {
      "type": 0,
      "value": "Il prezzo standard è di "
    },
    {
      "type": 1,
      "value": "amount"
    },
    {
      "type": 0,
      "value": " ciascuna"
    }
  ],
  "cart_thank_you_purchase": [
    {
      "type": 0,
      "value": "Grazie per il tuo acquisto!"
    }
  ],
  "cart_total": [
    {
      "type": 0,
      "value": "Totale"
    }
  ],
  "cart_unlock_all": [
    {
      "type": 0,
      "value": "Tutte le immagini digitali"
    }
  ],
  "cart_unlock_all_prints": [
    {
      "type": 0,
      "value": "Tutte le immagini e le stampe digitali"
    }
  ],
  "cart_unpurchased": [
    {
      "type": 0,
      "value": "Non acquistato"
    }
  ],
  "cart_view_photos": [
    {
      "type": 0,
      "value": "Vedi foto"
    }
  ],
  "cart_volume_discount_description": [
    {
      "type": 0,
      "value": "Acquista "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " immagine"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " immagini"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " e ricevi uno sconto del "
    },
    {
      "type": 1,
      "value": "percent"
    }
  ],
  "cart_volume_discount_label": [
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": " sconto "
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " o più"
    }
  ],
  "consumer_agreement": [
    {
      "type": 0,
      "value": "Utilizzando Capturelife accetti la nostra"
    }
  ],
  "consumer_confirm_password": [
    {
      "type": 0,
      "value": "Inserisci e conferma la tua password."
    }
  ],
  "consumer_confirm_your_password": [
    {
      "type": 0,
      "value": "Conferma password"
    }
  ],
  "consumer_contact_us": [
    {
      "type": 0,
      "value": "Contattaci"
    }
  ],
  "consumer_email_or_phone": [
    {
      "type": 0,
      "value": "Email o telefono"
    }
  ],
  "consumer_email_or_phone_long": [
    {
      "type": 0,
      "value": "Indirizzo email o numero di telefono"
    }
  ],
  "consumer_email_placeholder": [
    {
      "type": 0,
      "value": "E-mail"
    }
  ],
  "consumer_enter_email": [
    {
      "type": 0,
      "value": "Inserisci un indirizzo email."
    }
  ],
  "consumer_enter_password": [
    {
      "type": 0,
      "value": "Inserisci una password."
    }
  ],
  "consumer_enter_valid_email_phone": [
    {
      "type": 0,
      "value": "Inserisci un indirizzo email o un numero di telefono valido."
    }
  ],
  "consumer_footer_text": [
    {
      "type": 0,
      "value": "MONDO MAGICO e tutti i relativi marchi commerciali, personaggi, nomi e iniziali sono di proprietà © & ™ di Warner Bros. Entertainment Inc.© JKR. (s22)"
    }
  ],
  "consumer_forgot_password": [
    {
      "type": 0,
      "value": "Inserisci il tuo indirizzo email o il numero di telefono per reimpostare la password"
    }
  ],
  "consumer_forgot_your_password": [
    {
      "type": 0,
      "value": "Password dimenticata?"
    }
  ],
  "consumer_image_view_print_store": [
    {
      "type": 0,
      "value": "Print Store"
    }
  ],
  "consumer_item_generate_qr_code": [
    {
      "type": 0,
      "value": "Genera codice QR"
    }
  ],
  "consumer_link_expired": [
    {
      "type": 0,
      "value": "Spiacente, questo link è scaduto. Inserisci la tua email o il numero di telefono per ricevere un altro link."
    }
  ],
  "consumer_logging_in": [
    {
      "type": 0,
      "value": "Accesso in corso..."
    }
  ],
  "consumer_login_message": [
    {
      "type": 0,
      "value": "Torna per registrare quei momenti!"
    }
  ],
  "consumer_missing_something_error": [
    {
      "type": 0,
      "value": "Ops, sembra che ti sia sfuggito qualcosa."
    }
  ],
  "consumer_my_personal_data": [
    {
      "type": 0,
      "value": "I miei dati personali"
    }
  ],
  "consumer_nav_add_photos": [
    {
      "type": 0,
      "value": "Aggiungi foto"
    }
  ],
  "consumer_nav_add_photos_mobile": [
    {
      "type": 0,
      "value": "Aggiungi"
    }
  ],
  "consumer_nav_back": [
    {
      "type": 0,
      "value": "Indietro"
    }
  ],
  "consumer_nav_download": [
    {
      "type": 0,
      "value": "Scarica"
    }
  ],
  "consumer_nav_home": [
    {
      "type": 0,
      "value": "Home"
    }
  ],
  "consumer_nav_logout": [
    {
      "type": 0,
      "value": "Esci"
    }
  ],
  "consumer_nav_news": [
    {
      "type": 0,
      "value": "Notizie"
    }
  ],
  "consumer_nav_print_store": [
    {
      "type": 0,
      "value": "Print Store"
    }
  ],
  "consumer_nav_profile": [
    {
      "type": 0,
      "value": "Profilo"
    }
  ],
  "consumer_nav_refresh": [
    {
      "type": 0,
      "value": "Aggiorna"
    }
  ],
  "consumer_nav_share": [
    {
      "type": 0,
      "value": "Condividi"
    }
  ],
  "consumer_password_alteast_length": [
    {
      "type": 0,
      "value": "La password deve contenere almeno "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " caratteri."
    }
  ],
  "consumer_password_placeholder": [
    {
      "type": 0,
      "value": "Password"
    }
  ],
  "consumer_passwords_dont_match": [
    {
      "type": 0,
      "value": "La password e la password di conferma non corrispondono."
    }
  ],
  "consumer_qr_text": [
    {
      "type": 0,
      "value": "Fai uno screenshot del tuo codice QR o clicca sul pulsante Download qui sotto"
    }
  ],
  "consumer_reset_password": [
    {
      "type": 0,
      "value": "Reimposta password"
    }
  ],
  "consumer_resetting_password": [
    {
      "type": 0,
      "value": "Reimposta password in corso..."
    }
  ],
  "consumer_retake_photo_button": [
    {
      "type": 0,
      "value": "Take a Photo"
    }
  ],
  "consumer_search_photo_button": [
    {
      "type": 0,
      "value": "Search for photos"
    }
  ],
  "consumer_select_all": [
    {
      "type": 0,
      "value": "Seleziona tutto"
    }
  ],
  "consumer_selfie_button": [
    {
      "type": 0,
      "value": "Choose a selfie"
    }
  ],
  "consumer_selfie_instructions": [
    {
      "type": 0,
      "value": "Upload a selfie to get started"
    }
  ],
  "consumer_selfie_upload_complete": [
    {
      "type": 0,
      "value": "Selfie successfully uploaded"
    }
  ],
  "consumer_selfie_upload_failed": [
    {
      "type": 0,
      "value": "An error occurred.  Please try again"
    }
  ],
  "consumer_selfie_upload_in_progress": [
    {
      "type": 0,
      "value": "Upload in progress"
    }
  ],
  "consumer_share_dialog_notes": [
    {
      "type": 0,
      "value": "Per scaricare o condividere un'immagine, tocca a lungo l'immagine per visualizzare le opzioni di condivisione del dispositivo."
    }
  ],
  "consumer_store_title": [
    {
      "type": 0,
      "value": "Negozio online"
    }
  ],
  "consumer_take_photo_button": [
    {
      "type": 0,
      "value": "Take a Photo"
    }
  ],
  "consumer_terms_of_use": [
    {
      "type": 0,
      "value": "Termini di utilizzo"
    }
  ],
  "consumer_update_email": [
    {
      "type": 0,
      "value": "Inserisci l'email e la password che desideri utilizzare."
    }
  ],
  "consumer_update_password": [
    {
      "type": 0,
      "value": "Aggiorna password"
    }
  ],
  "consumer_update_your_password": [
    {
      "type": 0,
      "value": "Aggiorna la tua password"
    }
  ],
  "consumer_updating_password": [
    {
      "type": 0,
      "value": "Aggiornamento password in corso..."
    }
  ],
  "consumer_welcome_back": [
    {
      "type": 0,
      "value": "Che bello, sei di nuovo qui!"
    }
  ],
  "error_coupon_minimum": [
    {
      "type": 0,
      "value": "Non è possibile applicare il codice sconto. Il totale dell'acquisto è inferiore all'importo minimo necessario"
    }
  ],
  "error_coupon_not_found": [
    {
      "type": 0,
      "value": "Codice sconto non trovato"
    }
  ],
  "error_email_invalid": [
    {
      "type": 0,
      "value": "Inserisci un indirizzo email reale."
    }
  ],
  "error_email_required": [
    {
      "type": 0,
      "value": "Inserisci il tuo indirizzo email."
    }
  ],
  "error_fields_required": [
    {
      "type": 0,
      "value": "Compila i campi qui sotto."
    }
  ],
  "error_reservation_not_found": [
    {
      "type": 0,
      "value": "Prenotazione non trovata."
    }
  ],
  "error_scan_band": [
    {
      "type": 0,
      "value": "Nessuna foto per questo account. Scansiona un braccialetto che utilizzato nella stazione fotografica."
    }
  ],
  "error_see_attendant": [
    {
      "type": 0,
      "value": "Nessuna foto per questo account. Parla con un fotografo o un commesso"
    }
  ],
  "form_label_credit_or_debit_card": [
    {
      "type": 0,
      "value": "Carta di credito o di debito"
    }
  ],
  "form_label_customers_name": [
    {
      "type": 0,
      "value": "Customer's Name"
    }
  ],
  "form_label_email": [
    {
      "type": 0,
      "value": "E-mail"
    }
  ],
  "form_label_email_address": [
    {
      "type": 0,
      "value": "Indirizzo e-mail"
    }
  ],
  "form_label_last_name": [
    {
      "type": 0,
      "value": "Cognome"
    }
  ],
  "form_label_password": [
    {
      "type": 0,
      "value": "Password"
    }
  ],
  "form_label_pin": [
    {
      "type": 0,
      "value": "Pin"
    }
  ],
  "form_label_price": [
    {
      "type": 0,
      "value": "Prezzo (in "
    },
    {
      "type": 1,
      "value": "currency"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "form_label_room_number": [
    {
      "type": 0,
      "value": "Numero della camera"
    }
  ],
  "form_label_secret_code": [
    {
      "type": 0,
      "value": "Codice segreto"
    }
  ],
  "form_label_select_all": [
    {
      "type": 0,
      "value": "Seleziona tutto"
    }
  ],
  "form_label_unlock_all": [
    {
      "type": 0,
      "value": "Sblocca tutte le immagini"
    }
  ],
  "kiosk_approval_form_header": [
    {
      "type": 0,
      "value": "Necessaria approvazione"
    }
  ],
  "kiosk_approval_form_instructions": [
    {
      "type": 0,
      "value": "Richiedi assistenza"
    }
  ],
  "kiosk_attendant_form_header": [
    {
      "type": 0,
      "value": "Approva l'acquisto"
    }
  ],
  "kiosk_attendant_form_instructions": [
    {
      "type": 0,
      "value": "Inserisci il prezzo per questo acquisto."
    }
  ],
  "kiosk_auto_logout_subtitle": [
    {
      "type": 0,
      "value": "Verrai disconnesso automaticamente in "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " second"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " seconds"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "kiosk_auto_logout_title": [
    {
      "type": 0,
      "value": "Ehi, sei ancora qui?"
    }
  ],
  "kiosk_cart_count_verbose": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " immagine digitale"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " immagini digitali"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "imageCount"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " stampa"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " stampe"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "printCount"
    }
  ],
  "kiosk_cart_header": [
    {
      "type": 0,
      "value": "Rivedi e acquista"
    }
  ],
  "kiosk_cart_instructions": [
    {
      "type": 0,
      "value": "Tocca "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": "per rimuovere un'immagine dal carrello. Tocca "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "COMPLETA L'ACQUISTO"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " per continuare."
    }
  ],
  "kiosk_catalog_header": [
    {
      "type": 0,
      "value": "Aggiungi immagini alla tua galleria"
    }
  ],
  "kiosk_catalog_header_no_gallery": [
    {
      "type": 0,
      "value": "Seleziona le immagini da acquistare"
    }
  ],
  "kiosk_catalog_instructions": [
    {
      "type": 0,
      "value": "Tocca le immagini per aggiungerle alla tua galleria. Tocca VEDI LA "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "GALLERIA "
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "per tornare alla tua galleria."
    }
  ],
  "kiosk_catalog_instructions_no_gallery": [
    {
      "type": 0,
      "value": "Tocca le immagini per aggiungerle all'ordine. Tocca "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "RIVEDI E ACQUISTA"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "per continuare."
    }
  ],
  "kiosk_catalog_loading_message": [
    {
      "type": 0,
      "value": "Immagini in caricamento..."
    }
  ],
  "kiosk_edit_moment_adjust_subject": [
    {
      "type": 0,
      "value": "Adjust Subject"
    }
  ],
  "kiosk_edit_moment_apply_changes": [
    {
      "type": 0,
      "value": "Apply Changes"
    }
  ],
  "kiosk_edit_moment_apply_overlay": [
    {
      "type": 0,
      "value": "Apply Overlay"
    }
  ],
  "kiosk_edit_moment_back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "kiosk_edit_moment_close_confirmation": [
    {
      "type": 0,
      "value": "All changes you have made will be discarded. Are you sure you want to continue?"
    }
  ],
  "kiosk_edit_moment_complete_edit": [
    {
      "type": 0,
      "value": "Complete Edit"
    }
  ],
  "kiosk_edit_moment_crop_image": [
    {
      "type": 0,
      "value": "Crop Image"
    }
  ],
  "kiosk_edit_moment_done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "kiosk_edit_moment_next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "kiosk_gallery_header": [
    {
      "type": 0,
      "value": "Seleziona e acquista"
    }
  ],
  "kiosk_gallery_header_clubmed": [
    {
      "type": 0,
      "value": "La tua galleria delle immagini"
    }
  ],
  "kiosk_gallery_header_pre_print": [
    {
      "type": 0,
      "value": "Seleziona e stampa"
    }
  ],
  "kiosk_gallery_header_unlocked": [
    {
      "type": 0,
      "value": "La tua galleria delle immagini"
    }
  ],
  "kiosk_gallery_instructions": [
    {
      "type": 0,
      "value": "Tocca l'immagine per selezionarla per l'acquisto. Tocca "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "buttonLabel"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " per continuare."
    }
  ],
  "kiosk_gallery_instructions_empty_gallery": [
    {
      "type": 0,
      "value": "La galleria è vuota. Tocca "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "ALTRE IMMAGINI"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " nell'angolo in alto a destra dello schermo per cercare tra le altre immagini disponibili."
    }
  ],
  "kiosk_gallery_instructions_pre_print": [
    {
      "type": 0,
      "value": "Tocca l'icona di stampa su un'immagine per selezionarla per la stampa. Tocca il pulsante Stampa per scaricare le immagini selezionate"
    }
  ],
  "kiosk_gallery_instructions_prints": [
    {
      "type": 0,
      "value": "Tocca l'immagine per selezionarla per l'acquisto. Tocca due volte per richiedere una stampa. Tocca "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "buttonLabel"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " per continuare."
    }
  ],
  "kiosk_gallery_instructions_unlocked": [
    {
      "type": 0,
      "value": "Hai sbloccato tutte le immagini. Tocca "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " per rimuoverle dalla galleria."
    }
  ],
  "kiosk_gallery_instructions_unlocked_prints": [
    {
      "type": 0,
      "value": "Hai sbloccato tutte le immagini. Tocca un'immagine per richiedere la stampa. Tocca "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " per rimuoverle dalla galleria."
    }
  ],
  "kiosk_image_tooltip_add_print": [
    {
      "type": 0,
      "value": "Aggiungi stampe"
    }
  ],
  "kiosk_image_tooltip_digital_purchased": [
    {
      "type": 0,
      "value": "Digitale acquistata"
    }
  ],
  "kiosk_image_tooltip_print_purchased": [
    {
      "type": 0,
      "value": "Stampa acquistata"
    }
  ],
  "kiosk_image_tooltip_print_selected": [
    {
      "type": 0,
      "value": "Stampa selezionata"
    }
  ],
  "kiosk_image_tooltip_remove_print": [
    {
      "type": 0,
      "value": "Rimuovi stampa"
    }
  ],
  "kiosk_image_tooltip_select_print": [
    {
      "type": 0,
      "value": "Seleziona stampa"
    }
  ],
  "kiosk_images_header": [
    {
      "type": 0,
      "value": "Le tue immagini"
    }
  ],
  "kiosk_images_header_clubmed": [
    {
      "type": 0,
      "value": "Seleziona immagini"
    }
  ],
  "kiosk_images_header_selected": [
    {
      "type": 0,
      "value": "La tua selezione"
    }
  ],
  "kiosk_login_header_access_your_images": [
    {
      "type": 0,
      "value": "Accedi alle tue immagini"
    }
  ],
  "kiosk_login_header_clubmed": [
    {
      "type": 0,
      "value": "Inserisci il numero della camera, il cognome e l'email per accedere alla galleria"
    }
  ],
  "kiosk_login_header_preprint": [
    {
      "type": 0,
      "value": "Pre-Print Gallery"
    }
  ],
  "kiosk_login_header_welcome": [
    {
      "type": 0,
      "value": "Ciao!"
    }
  ],
  "kiosk_login_hpx_footer_text": [
    {
      "type": 0,
      "value": "MONDO MAGICO e tutti i relativi marchi commerciali, personaggi, nomi e iniziali sono di proprietà © & ™ di Warner Bros. Entertainment Inc.© JKR. (s22)"
    }
  ],
  "kiosk_login_instructions_enter_email": [
    {
      "type": 0,
      "value": "Inserisci il tuo indirizzo email per continuare."
    }
  ],
  "kiosk_login_instructions_scan_band": [
    {
      "type": 0,
      "value": "Scansiona il tuo braccialetto per iniziare"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_header": [
    {
      "type": 0,
      "value": "Conto della camera"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_instructions": [
    {
      "type": 0,
      "value": "Il totale indicato di seguito verrà addebitato sulla tua camera"
    }
  ],
  "kiosk_offsite_pos_form_generic_header": [
    {
      "type": 0,
      "value": "Completa l'acquisto"
    }
  ],
  "kiosk_offsite_pos_form_generic_instructions": [
    {
      "type": 0,
      "value": "Il tuo ordine include:"
    }
  ],
  "kiosk_order_details_disclaimer_no_refunds": [
    {
      "type": 0,
      "value": "* Tutte le vendite sono definitive e non è possibile fornire rimborsi."
    }
  ],
  "kiosk_order_details_header": [
    {
      "type": 0,
      "value": "Dettagli dell'ordine"
    }
  ],
  "kiosk_order_details_instructions": [
    {
      "type": 0,
      "value": "Tocca le immagini a sinistra per selezionarle e acquistarle."
    }
  ],
  "kiosk_order_details_instructions_cart_empty": [
    {
      "type": 0,
      "value": "Il carrello è vuoto. Tocca le immagini per aggiungerle all'ordine."
    }
  ],
  "kiosk_order_details_instructions_cart_empty_more_images": [
    {
      "type": 0,
      "value": "Il carrello è vuoto. Tocca "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "AGGIUNGI ALTRE IMMAGINI"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " per aggiungere altre immagini"
    }
  ],
  "kiosk_order_details_instructions_email": [
    {
      "type": 0,
      "value": "Riceverai le immagini via e-mail"
    }
  ],
  "kiosk_order_details_instructions_prints": [
    {
      "type": 0,
      "value": "Tocca due volte un'immagine per richiederne la stampa."
    }
  ],
  "kiosk_payment_method_form_header": [
    {
      "type": 0,
      "value": "Completa l'acquisto"
    }
  ],
  "kiosk_payment_method_form_instructions": [
    {
      "type": 0,
      "value": "Come desideri completare l'acquisto?"
    }
  ],
  "kiosk_price_guide_header": [
    {
      "type": 0,
      "value": "Guida ai prezzi"
    }
  ],
  "kiosk_price_guide_instructions": [
    {
      "type": 0,
      "value": "Acquista altre immagini per ottenere uno sconto"
    }
  ],
  "kiosk_price_guide_instructions_standard_price": [
    {
      "type": 0,
      "value": "Il prezzo standard è "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " per immagine"
    }
  ],
  "kiosk_price_guide_instructions_unlocked": [
    {
      "type": 0,
      "value": "Puoi aggiungere altre immagini senza alcun costo"
    }
  ],
  "kiosk_print_size_edits_cancel": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "kiosk_print_size_edits_continue": [
    {
      "type": 0,
      "value": "Continue"
    }
  ],
  "kiosk_print_size_edits_create": [
    {
      "type": 0,
      "value": "Create"
    }
  ],
  "kiosk_print_size_select_header": [
    {
      "type": 0,
      "value": "Dimensioni di stampa"
    }
  ],
  "kiosk_print_size_select_instructions": [
    {
      "type": 0,
      "value": "Seleziona le dimensioni di stampa e il numero"
    }
  ],
  "kiosk_processing_edited_moment": [
    {
      "type": 0,
      "value": "Processing edited moment..."
    }
  ],
  "kiosk_processing_payment": [
    {
      "type": 0,
      "value": "Elaborazione pagamento..."
    }
  ],
  "kiosk_purchase_details_discounts_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "Sconti offerti:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_packages_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "Pacchetti offerti:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_per_image": [
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " per immagine"
    }
  ],
  "kiosk_purchase_details_standard_price": [
    {
      "children": [
        {
          "type": 0,
          "value": "Prezzo standard:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_total": [
    {
      "children": [
        {
          "type": 0,
          "value": "Totale:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_disabled_instructions": [
    {
      "type": 0,
      "value": "Tocca le immagini per aggiungerle all'ordine"
    }
  ],
  "kiosk_purchase_disabled_instructions_more_images": [
    {
      "type": 0,
      "value": "Tocca le immagini per selezionarle o deselezionarle per l'acquisto. Per aggiungere altre immagini dalla selezione, tocca "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "ALTRE IMMAGINI"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_reader_not_connected": [
    {
      "type": 0,
      "value": "Lettore non connesso"
    }
  ],
  "kiosk_reader_payment_failed": [
    {
      "type": 0,
      "value": "Elaborazione del lettore non riuscita"
    }
  ],
  "kiosk_reader_standby": [
    {
      "type": 0,
      "value": "Lettore in standby..."
    }
  ],
  "kiosk_receipt_header": [
    {
      "type": 0,
      "value": "Acquisto completato"
    }
  ],
  "kiosk_receipt_instructions": [
    {
      "type": 0,
      "value": "Un link alla tua galleria è stato inviato a "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "email"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ". "
    }
  ],
  "kiosk_remove_modal_instructions": [
    {
      "type": 0,
      "value": "Desideri rimuovere questa immagine dal tuo ordine? Cercala di nuovo toccando "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "AGGIUNGI ALTRE IMMAGINI"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_room_dialog_header": [
    {
      "type": 0,
      "value": "Camera "
    },
    {
      "type": 1,
      "value": "room"
    }
  ],
  "kiosk_room_dialog_header_multiple": [
    {
      "type": 0,
      "value": "Camere "
    },
    {
      "type": 1,
      "value": "rooms"
    }
  ],
  "kiosk_room_dialog_instructions_link_sent": [
    {
      "type": 0,
      "value": "Un link è stato inviato per email a "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "email"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_selected_print_size": [
    {
      "type": 0,
      "value": "Print Size"
    }
  ],
  "kiosk_selected_print_sizes_aspect_column": [
    {
      "type": 0,
      "value": "Proporzioni"
    }
  ],
  "kiosk_selected_print_sizes_header": [
    {
      "type": 0,
      "value": "Stampe selezionate"
    }
  ],
  "kiosk_selected_print_sizes_photo_column": [
    {
      "type": 0,
      "value": "Momento"
    }
  ],
  "kiosk_selected_print_sizes_quantity_column": [
    {
      "type": 0,
      "value": "Quantità"
    }
  ],
  "kiosk_selected_print_sizes_size_column": [
    {
      "type": 0,
      "value": "Dimensioni di stampa"
    }
  ],
  "kiosk_stripe_form_header": [
    {
      "type": 0,
      "value": "Completa l'acquisto"
    }
  ],
  "kiosk_stripe_form_header_clubmed": [
    {
      "type": 0,
      "value": "Inserisci informazioni di pagamento"
    }
  ],
  "kiosk_topbar_welcome_message": [
    {
      "type": 0,
      "value": "Benvenuto, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "kiosk_welcome_message": [
    {
      "type": 0,
      "value": "Benvenuto, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "!"
    }
  ]
}